<button class="go-back-button" (click)="handleNavigateToPreviousPage($event)">
  <svg-icon src="assets/images/icons/seta-esquerda.svg"></svg-icon>
  {{ name }}
</button>

